import topTitle from '@/views/template/components/title';
export default {
  components: {
    topTitle
  },
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageType: {
      type: String,
      default: ''
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [{
        name: '保障期限',
        value: '1年',
        icon: 'term'
      }, {
        name: '保障年龄',
        value: '1-99岁',
        icon: 'age'
      }, {
        name: '承保范围',
        value: '全国',
        icon: 'range'
      }, {
        name: '承保职业',
        value: '1-4类',
        icon: 'occupation'
      }, {
        name: '承保额度',
        value: '12.25万',
        icon: 'quota'
      }, {
        name: '生效日期',
        value: '1投保日T+7',
        icon: 'date'
      }]
    };
  }
};